module.exports = __webpack_public_path__ + "img/invoiceInsert.4abef9c2.png";